import type { Property, PropertySerializationResult, Entity } from '@cognitoforms/model.js';
import { PropertyConverter } from '@cognitoforms/model.js';

export default class DateConverter extends PropertyConverter {
	shouldConvert(context: Entity, prop: Property): boolean {
		return prop.propertyType === Date && prop.format.specifier === 'd';
	}

	serialize(context: Entity, value: any, prop: Property): PropertySerializationResult {
		return {
			key: prop.name,
			value: Array.isArray(value)
				? value.map(date => this.formatDate(date))
				: value ? this.formatDate(value) : null
		};
	}

	deserialize(context: Entity, value: any, prop: Property) {
		if (Array.isArray(value))
			return value.map(date => typeof date === 'string' ? this.parseDate(date) : date);
		if (typeof value === 'string')
			return this.parseDate(value);
		return value;
	}

	private formatDate(date: Date) {
		return date.getFullYear()
			+ (date.getMonth() < 9 ? '-0' : '-') + (date.getMonth() + 1)
			+ (date.getDate() < 10 ? '-0' : '-') + date.getDate();
	}

	private parseDate(date: string) {
		const parts = date.split('-').map(Number);
		return new Date(parts[0], parts[1] - 1, parts[2]);
	}
}
